var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Err, Errors, Field, FieldWrapper, Helper, Input, Label } from './form-elements/shared.js';
import Copy from './copy.js';
import { focusWithoutScroll, isEmpty, capitalize } from '@navinc/utils';
import { PasswordStrengthMeter } from './password-strength-meter.js';
const StyledPasswordStrengthMeter = styled(PasswordStrengthMeter).withConfig({ displayName: "brc-StyledPasswordStrengthMeter", componentId: "brc-1kxmzi3" }) `
  margin: 0 ${({ theme }) => theme.gu(2)};
  text-align: 'left';
`;
const combineRefs = (...refs) => (value) => {
    refs.forEach((ref) => {
        if (ref) {
            ref.current = value;
        }
    });
};
export const InputField = (_a) => {
    var { autoFocus, children, className, label = '', hasSpaceForErrors, helperIcon, helperLinkAction, helperText, isInvalid, isStatic, value, required, type, errors = [], lede = '', touched, placeholder, passwordStrengthScore, requiredPasswordScore, innerRef } = _a, props = __rest(_a, ["autoFocus", "children", "className", "label", "hasSpaceForErrors", "helperIcon", "helperLinkAction", "helperText", "isInvalid", "isStatic", "value", "required", "type", "errors", "lede", "touched", "placeholder", "passwordStrengthScore", "requiredPasswordScore", "innerRef"]);
    /* isStatic to be used to overcome auto-populated fields that do not read as values or placeholders */
    const isVisited = touched || !isEmpty(value) || typeof value === 'number' || placeholder || isStatic;
    const inputRef = useRef(null);
    const combinedRefs = combineRefs(inputRef, innerRef);
    useEffect(() => {
        if (autoFocus) {
            focusWithoutScroll(inputRef.current);
        }
    }, [autoFocus]);
    return (_jsxs(FieldWrapper, Object.assign({ className: className }, { children: [lede && _jsx(Copy, Object.assign({ bold: true }, { children: lede })), _jsxs(Field, Object.assign({ isVisited: isVisited, isInvalid: isInvalid, required: required, type: type }, { children: [_jsx(Input, Object.assign({ isInvalid: isInvalid, placeholder: placeholder, ref: combinedRefs, required: required, type: type, value: value }, props)), children, _jsx(Label, Object.assign({ required: required, value: value }, { children: capitalize(label) }))] })), helperText && (_jsx(Helper, { iconName: helperIcon, helperLinkAction: helperLinkAction, hasSpaceForHelper: hasSpaceForErrors, helperText: helperText })), passwordStrengthScore >= 0 && (_jsx(StyledPasswordStrengthMeter, { passwordStrengthScore: passwordStrengthScore, requiredPasswordScore: requiredPasswordScore })), _jsx(Errors, Object.assign({ hasSpaceForErrors: hasSpaceForErrors }, { children: !!errors.length && errors.map((err, i) => _jsx(Err, { children: err }, `err-${i}`)) }))] })));
};
const StyledInput = styled(InputField).withConfig({ displayName: "brc-StyledInput", componentId: "brc-tgx4wn" }) ``;
export default StyledInput;
//# sourceMappingURL=input.js.map